import type {RelayCompat} from '@github-ui/server-persisted-queries/relay-compat'
import type {IssueViewerSecondaryViewQueryQuery} from '@github-ui/server-persisted-queries/types/IssueViewerSecondaryViewQuery'

import {LABELS} from '../constants/labels'
import styles from './MarkdownLastEditedBy.module.css'

type IssueSecondaryNode = NonNullable<NonNullable<IssueViewerSecondaryViewQueryQuery['repository']>['issue']>

type LastUserContentEditEditor = NonNullable<NonNullable<IssueSecondaryNode['lastUserContentEdit']>['editor']>

export type MarkdownLastEditedByFragment = RelayCompat<{
  readonly viewerCanReadUserContentEdits: IssueSecondaryNode['viewerCanReadUserContentEdits']
  readonly lastUserContentEdit: {
    readonly editor: Pick<LastUserContentEditEditor, 'url' | 'login'> | null
  } | null
}>

type MarkdownLastEditedByProps = {
  editInformation?: MarkdownLastEditedByFragment
}

export function MarkdownLastEditedBy({editInformation: data}: MarkdownLastEditedByProps) {
  if (!data || !data.viewerCanReadUserContentEdits || !data.lastUserContentEdit || !data.lastUserContentEdit.editor) {
    return null
  }

  const {login} = data.lastUserContentEdit.editor

  return (
    <span className={styles.lastEditInfoContainer}>
      {`${LABELS.editHistory.editedBy} `}
      <span className={styles.editorLogin}>{login}</span>
    </span>
  )
}
